/* Auto-generated Lucide icon nodes for webpack 3 / Vue 2. Do not edit by hand. */
export default {
  "Home": [
    [
      "path",
      {
        "d": "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"
      }
    ],
    [
      "path",
      {
        "d": "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
      }
    ]
  ],
  "MapPin": [
    [
      "path",
      {
        "d": "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
      }
    ],
    [
      "circle",
      {
        "cx": "12",
        "cy": "10",
        "r": "3"
      }
    ]
  ],
  "UserCog": [
    [
      "path",
      {
        "d": "M10 15H6a4 4 0 0 0-4 4v2"
      }
    ],
    [
      "path",
      {
        "d": "m14.305 16.53.923-.382"
      }
    ],
    [
      "path",
      {
        "d": "m15.228 13.852-.923-.383"
      }
    ],
    [
      "path",
      {
        "d": "m16.852 12.228-.383-.923"
      }
    ],
    [
      "path",
      {
        "d": "m16.852 17.772-.383.924"
      }
    ],
    [
      "path",
      {
        "d": "m19.148 12.228.383-.923"
      }
    ],
    [
      "path",
      {
        "d": "m19.53 18.696-.382-.924"
      }
    ],
    [
      "path",
      {
        "d": "m20.772 13.852.924-.383"
      }
    ],
    [
      "path",
      {
        "d": "m20.772 16.148.924.383"
      }
    ],
    [
      "circle",
      {
        "cx": "18",
        "cy": "15",
        "r": "3"
      }
    ],
    [
      "circle",
      {
        "cx": "9",
        "cy": "7",
        "r": "4"
      }
    ]
  ],
  "Users": [
    [
      "path",
      {
        "d": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
      }
    ],
    [
      "path",
      {
        "d": "M16 3.128a4 4 0 0 1 0 7.744"
      }
    ],
    [
      "path",
      {
        "d": "M22 21v-2a4 4 0 0 0-3-3.87"
      }
    ],
    [
      "circle",
      {
        "cx": "9",
        "cy": "7",
        "r": "4"
      }
    ]
  ],
  "Newspaper": [
    [
      "path",
      {
        "d": "M15 18h-5"
      }
    ],
    [
      "path",
      {
        "d": "M18 14h-8"
      }
    ],
    [
      "path",
      {
        "d": "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2"
      }
    ],
    [
      "rect",
      {
        "width": "8",
        "height": "4",
        "x": "10",
        "y": "6",
        "rx": "1"
      }
    ]
  ],
  "MessageSquare": [
    [
      "path",
      {
        "d": "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
      }
    ]
  ],
  "DollarSign": [
    [
      "line",
      {
        "x1": "12",
        "x2": "12",
        "y1": "2",
        "y2": "22"
      }
    ],
    [
      "path",
      {
        "d": "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
      }
    ]
  ],
  "ClipboardList": [
    [
      "rect",
      {
        "width": "8",
        "height": "4",
        "x": "8",
        "y": "2",
        "rx": "1",
        "ry": "1"
      }
    ],
    [
      "path",
      {
        "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
      }
    ],
    [
      "path",
      {
        "d": "M12 11h4"
      }
    ],
    [
      "path",
      {
        "d": "M12 16h4"
      }
    ],
    [
      "path",
      {
        "d": "M8 11h.01"
      }
    ],
    [
      "path",
      {
        "d": "M8 16h.01"
      }
    ]
  ],
  "Store": [
    [
      "path",
      {
        "d": "M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5"
      }
    ],
    [
      "path",
      {
        "d": "M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244"
      }
    ],
    [
      "path",
      {
        "d": "M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05"
      }
    ]
  ],
  "Gift": [
    [
      "path",
      {
        "d": "M12 7v14"
      }
    ],
    [
      "path",
      {
        "d": "M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8"
      }
    ],
    [
      "path",
      {
        "d": "M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5"
      }
    ],
    [
      "rect",
      {
        "x": "3",
        "y": "7",
        "width": "18",
        "height": "4",
        "rx": "1"
      }
    ]
  ],
  "BookOpen": [
    [
      "path",
      {
        "d": "M12 5v16"
      }
    ],
    [
      "path",
      {
        "d": "M20.001 19A2 2 0 0022 17V5a2 2 0 00-1.999-2L16 3.002A5 5 0 0012 5a5 5 0 00-4-2H4a2 2 0 00-2 2v12a2 2 0 001.999 2H8a5 5 0 014 2 5 5 0 014-2z"
      }
    ]
  ],
  "UsersRound": [
    [
      "path",
      {
        "d": "M18 21a8 8 0 0 0-16 0"
      }
    ],
    [
      "circle",
      {
        "cx": "10",
        "cy": "8",
        "r": "5"
      }
    ],
    [
      "path",
      {
        "d": "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"
      }
    ]
  ],
  "Phone": [
    [
      "path",
      {
        "d": "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"
      }
    ]
  ],
  "Package": [
    [
      "path",
      {
        "d": "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"
      }
    ],
    [
      "path",
      {
        "d": "M12 22V12"
      }
    ],
    [
      "polyline",
      {
        "points": "3.29 7 12 12 20.71 7"
      }
    ],
    [
      "path",
      {
        "d": "m7.5 4.27 9 5.15"
      }
    ]
  ],
  "Shield": [
    [
      "path",
      {
        "d": "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
      }
    ]
  ],
  "Bell": [
    [
      "path",
      {
        "d": "M10.268 21a2 2 0 0 0 3.464 0"
      }
    ],
    [
      "path",
      {
        "d": "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"
      }
    ]
  ],
  "CalendarDays": [
    [
      "path",
      {
        "d": "M8 2v3"
      }
    ],
    [
      "path",
      {
        "d": "M16 2v3"
      }
    ],
    [
      "rect",
      {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2"
      }
    ],
    [
      "path",
      {
        "d": "M3 9h18"
      }
    ],
    [
      "path",
      {
        "d": "M8 13h.01"
      }
    ],
    [
      "path",
      {
        "d": "M12 13h.01"
      }
    ],
    [
      "path",
      {
        "d": "M16 13h.01"
      }
    ],
    [
      "path",
      {
        "d": "M8 17h.01"
      }
    ],
    [
      "path",
      {
        "d": "M12 17h.01"
      }
    ],
    [
      "path",
      {
        "d": "M16 17h.01"
      }
    ]
  ],
  "AlarmClock": [
    [
      "circle",
      {
        "cx": "12",
        "cy": "13",
        "r": "8"
      }
    ],
    [
      "path",
      {
        "d": "M12 9v4l2 2"
      }
    ],
    [
      "path",
      {
        "d": "M5 3 2 6"
      }
    ],
    [
      "path",
      {
        "d": "m22 6-3-3"
      }
    ],
    [
      "path",
      {
        "d": "M6.38 18.7 4 21"
      }
    ],
    [
      "path",
      {
        "d": "M17.64 18.67 20 21"
      }
    ]
  ],
  "Smartphone": [
    [
      "rect",
      {
        "width": "14",
        "height": "20",
        "x": "5",
        "y": "2",
        "rx": "2",
        "ry": "2"
      }
    ],
    [
      "path",
      {
        "d": "M12 18h.01"
      }
    ]
  ],
  "Briefcase": [
    [
      "path",
      {
        "d": "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
      }
    ],
    [
      "rect",
      {
        "width": "20",
        "height": "14",
        "x": "2",
        "y": "6",
        "rx": "2"
      }
    ]
  ],
  "Calendar": [
    [
      "path",
      {
        "d": "M8 2v3"
      }
    ],
    [
      "path",
      {
        "d": "M16 2v3"
      }
    ],
    [
      "rect",
      {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2"
      }
    ],
    [
      "path",
      {
        "d": "M3 9h18"
      }
    ]
  ],
  "Truck": [
    [
      "path",
      {
        "d": "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"
      }
    ],
    [
      "path",
      {
        "d": "M15 18H9"
      }
    ],
    [
      "path",
      {
        "d": "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"
      }
    ],
    [
      "circle",
      {
        "cx": "17",
        "cy": "18",
        "r": "2"
      }
    ],
    [
      "circle",
      {
        "cx": "7",
        "cy": "18",
        "r": "2"
      }
    ]
  ],
  "BadgeCheck": [
    [
      "path",
      {
        "d": "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
      }
    ],
    [
      "path",
      {
        "d": "m16 9-5.5 5.5L8 12"
      }
    ]
  ],
  "ClipboardCheck": [
    [
      "rect",
      {
        "width": "8",
        "height": "4",
        "x": "8",
        "y": "2",
        "rx": "1",
        "ry": "1"
      }
    ],
    [
      "path",
      {
        "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
      }
    ],
    [
      "path",
      {
        "d": "m9 14 2 2 4-4"
      }
    ]
  ],
  "HardHat": [
    [
      "path",
      {
        "d": "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5"
      }
    ],
    [
      "path",
      {
        "d": "M14 6a6 6 0 0 1 6 6v3"
      }
    ],
    [
      "path",
      {
        "d": "M4 15v-3a6 6 0 0 1 6-6"
      }
    ],
    [
      "rect",
      {
        "x": "2",
        "y": "15",
        "width": "20",
        "height": "4",
        "rx": "1"
      }
    ]
  ],
  "Recycle": [
    [
      "path",
      {
        "d": "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5"
      }
    ],
    [
      "path",
      {
        "d": "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12"
      }
    ],
    [
      "path",
      {
        "d": "m14 16-3 3 3 3"
      }
    ],
    [
      "path",
      {
        "d": "M8.293 13.596 7.196 9.5 3.1 10.598"
      }
    ],
    [
      "path",
      {
        "d": "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843"
      }
    ],
    [
      "path",
      {
        "d": "m13.378 9.633 4.096 1.098 1.097-4.096"
      }
    ]
  ],
  "Menu": [
    [
      "path",
      {
        "d": "M4 5h16"
      }
    ],
    [
      "path",
      {
        "d": "M4 12h16"
      }
    ],
    [
      "path",
      {
        "d": "M4 19h16"
      }
    ]
  ],
  "Search": [
    [
      "path",
      {
        "d": "m21 21-4.34-4.34"
      }
    ],
    [
      "circle",
      {
        "cx": "11",
        "cy": "11",
        "r": "8"
      }
    ]
  ],
  "ChevronDown": [
    [
      "path",
      {
        "d": "m6 9 6 6 6-6"
      }
    ]
  ],
  "ChevronUp": [
    [
      "path",
      {
        "d": "m18 15-6-6-6 6"
      }
    ]
  ],
  "Circle": [
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    ]
  ],
  "Box": [
    [
      "path",
      {
        "d": "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"
      }
    ],
    [
      "path",
      {
        "d": "m3.3 7 8.7 5 8.7-5"
      }
    ],
    [
      "path",
      {
        "d": "M12 22V12"
      }
    ]
  ],
  "PanelLeftClose": [
    [
      "rect",
      {
        "width": "18",
        "height": "18",
        "x": "3",
        "y": "3",
        "rx": "2"
      }
    ],
    [
      "path",
      {
        "d": "M9 3v18"
      }
    ],
    [
      "path",
      {
        "d": "m16 15-3-3 3-3"
      }
    ]
  ],
  "PanelLeftOpen": [
    [
      "rect",
      {
        "width": "18",
        "height": "18",
        "x": "3",
        "y": "3",
        "rx": "2"
      }
    ],
    [
      "path",
      {
        "d": "M9 3v18"
      }
    ],
    [
      "path",
      {
        "d": "m14 9 3 3-3 3"
      }
    ]
  ],
  "LogOut": [
    [
      "path",
      {
        "d": "m16 17 5-5-5-5"
      }
    ],
    [
      "path",
      {
        "d": "M21 12H9"
      }
    ],
    [
      "path",
      {
        "d": "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
      }
    ]
  ]
}



// WEBPACK FOOTER //
// ./src/components/layout/lucideIcons.js